var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('v-btn',{staticClass:"primary--text ml-0 ml-sm-3 barcode-btn",class:{ 'no-border': _vm.$vuetify.breakpoint.smAndDown },attrs:{"loading":_vm.loading,"large":!_vm.$vuetify.breakpoint.xs,"icon":""},on:{"click":function($event){return _vm.scan()}}},[_c('v-icon',[_vm._v(" $qrCode ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }